import { FP_DATA, FP_DELETE_SAVED_CARD, FP_UPI, FP_SET_PAY_RESP, FP_CC_CARD_META, FP_CHANGE_PAYMENT_VIEW, GET_MERCHANT_DATA, FP_DISABLE_ALL_PAYMENT_MODE,FP_TERMS_CONDITION_ACCEPT, FP_SET_TRANSACTION_AMOUNT, BHARATHQR_RESPONSE } from 'actions/types';

const initialState = {};

export default function handleInitState(state=initialState, action){
  switch(action.type){
    case FP_DATA:
      let returnData = {}
      if(action.payload.data){
        if(action.payload.data.response.errorCode){
          const { errorCode, errorMessage, redirectToRetryPayPage, redirectResponseBean, redirectUrl } = action.payload.data.response
          if(redirectResponseBean){
            returnData = { ...returnData, SessionToken: redirectResponseBean.newSessionToken, ConfigId: redirectResponseBean.previousConfigId }
          }
          returnData = { ...returnData, errorCode, errorMessage, redirectToRetryPayPage, redirectUrl }
        }else{  

          const { response: globalConfig, response: {mConfig: {lstMerchWallet,mrctTNCDetail,mSiOptionEnbaled: siEnabled, mDeftpaymentMode: selectedPayment, integrationType,mrchInstitutionId}, vaultedPaymentMethods: savedCards, transactionDetails, txnKey, txnIv} } = action.payload.data;
          //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
          returnData = { ...returnData, globalConfig, siEnabled,lstMerchWallet, savedCards, transactionDetails, txnKey, txnIv, selectedPayment, defaultSelectedPayment: selectedPayment, mrchInstitutionId,integrationType,mrch_tnc_details:mrctTNCDetail,termsStatus:false }
        // console.log("RETURNDATA",returnData);

        }
      }
      return { ...state, ...returnData }
      break;
    case FP_CC_CARD_META:
      return { ...state, ccCardMetaData: action.payload.data.response }
      break;
    case FP_DISABLE_ALL_PAYMENT_MODE:
      const {disableAllPaymentMode} = action.payload
      return {...state, disableAllPaymentView:disableAllPaymentMode}  
      break;
    case FP_SET_PAY_RESP:
      let setPayReturnData = { displayErrorMessage: null }
      if(action.payload.data.errorCode){
        const { errorCode, errorMessage, redirectToRetryPayPage, redirectResponseBean, redirectUrl } = action.payload.data
        if(redirectResponseBean){
          setPayReturnData = { ...setPayReturnData, SessionToken: redirectResponseBean.newSessionToken, ConfigId: redirectResponseBean.previousConfigId }
        }
        setPayReturnData = { ...setPayReturnData, errorCode, displayErrorMessage: errorMessage, redirectToRetryPayPage, redirectUrl }
      }
      return { ...state, ...setPayReturnData }
      break;
    case FP_DELETE_SAVED_CARD:
      const { vaultedPaymentMethods: savedCards} = action.payload.data
      return { ...state, savedCards: savedCards ? savedCards : [], selectedPayment: savedCards===undefined ? state.defaultSelectedPayment : state.selectedPayment}
      break;
    case FP_UPI:
      let setUPIReturnData = { displayErrorMessage: null }
      if(action.payload.data.errorCode){
        const { errorCode, errorMessage, redirectToRetryPayPage, redirectResponseBean, redirectUrl } = action.payload.data
        if(redirectResponseBean){
          setUPIReturnData = { ...setUPIReturnData, SessionToken: redirectResponseBean.newSessionToken, ConfigId: redirectResponseBean.previousConfigId }
        }
        setUPIReturnData = { ...setUPIReturnData, upiError: true, errorCode, displayErrorMessage: errorMessage, redirectToRetryPayPage, redirectUrl }
      }
      return { ...state, ...setUPIReturnData }
      break;
    case FP_CHANGE_PAYMENT_VIEW:
      if(action.payload){
        const { selectedPayment } = action.payload
        let returnData = {...state, selectedPayment, saveInfo: false}
        if(selectedPayment==='CREDITCARD_FROM_SC'){
          returnData = { ...returnData, selectedPayment: 'CREDITCARD', saveInfo: true}
        }
        return { ...returnData  }
      }
      break;
    case FP_TERMS_CONDITION_ACCEPT:
        const {termsStatus} = action.payload;
        return  {...state,termsStatus}
      break;  
    case GET_MERCHANT_DATA:
      const { SessionToken, ConfigId, lang } = action.payload
      return { ...state, SessionToken, ConfigId, lang };
      break;
    case FP_SET_TRANSACTION_AMOUNT:
      let amount = parseFloat(action.payload.amount)
      return { ...state, ...state.transactionDetails.amount = amount.toFixed(2)} 
      break;
    case BHARATHQR_RESPONSE:
      let response = { bharathQRData : null, displayErrorMessage: null}
      if(action.payload.data.errorCode){
        const { errorCode, errorMessage, redirectToRetryPayPage, redirectResponseBean, redirectUrl } = action.payload.data
        if(redirectResponseBean){
          response = { ...response, SessionToken: redirectResponseBean.newSessionToken, ConfigId: redirectResponseBean.previousConfigId }
        }
          response = { ...response, errorCode, displayErrorMessage: errorMessage, redirectToRetryPayPage, redirectUrl }
      } else {
        const { redirectResponseBean } = action.payload.data
        if(redirectResponseBean){
          response = { bharathQRData : null }
        }
          response = { bharathQRData : action.payload.data }
      }
      return { ...state, ...response }
      break;   
    default:
    return state;
  }
}